import React from 'react';
const PetShops = () => <div className="service-page"><h1>Pet Shops</h1><p>Find pet shops for all your pet care needs.</p></div>;
export default PetShops;
